import React from "react";
import BlueNavHeader from "./BlueNavHeader";
import { useLocation } from "react-router-dom";

function UserScreenWindow({ children, label }) {
  const location = useLocation();
  const isChatRoute =
    location.pathname.includes("/group-chats/") ||
    location.pathname.includes("/chats/");

  return (
    <div
      className={`${
        isChatRoute ? "h-full" : "min-h-screen"
      } flex flex-col text-left ${isChatRoute ? "pb-0 " : ""}`}
    >
      <BlueNavHeader label={label} />
      <div className="flex-1 flex flex-col pt-4 px-2">{children}</div>
    </div>
  );
}

export default UserScreenWindow;